module.exports = __webpack_public_path__ + "media/1x1/hn-c94622ad.svg";